# frozen_string_literal: true

module Engine
  module Publisher
    INFO = {
      all_aboard_games: {
        name: 'All-Aboard Games',
        url: 'https://all-aboardgames.com/',
      },
      deep_thought_games: {
        name: 'Deep Thought Games',
        url: 'https://boardgamegeek.com/boardgamepublisher/4192/deep-thought-games-llc',
        hidden: true,
      },
      gmt_games: {
        name: 'GMT Games',
        url: 'https://www.gmtgames.com/',
      },
      golden_spike: {
        name: 'Golden Spike Games',
        url: 'https://goldenspikegames.com/',
      },
      grand_trunk_games: {
        name: 'Grand Trunk Games',
        url: 'https://www.grandtrunkgames.com/',
      },
      lonny_games: {
        name: 'Lonny Games',
        url: 'https://www.lonnygames.com/',
      },
      lookout: {
        name: 'Lookout Games',
        url: 'https://lookout-spiele.de/',
        hidden: true,
      },
      loserdogs: {
        name: 'Loserdogs',
        url: 'http://tanisan.com/ld/',
        hidden: true,
      },
      marflow_games: {
        name: 'Marflow Games',
        url: 'https://18xx-marflow-games.de/',
      },
      mayfair: {
        name: 'Mayfair Games',
        url: 'https://boardgamegeek.com/boardgamepublisher/10/mayfair-games',
        hidden: true,
      },
      mercury: {
        name: 'Mercury Games',
        url: 'https://www.mercurygames.com/',
        hidden: true,
      },
      oo_games: {
        name: 'Double-O Games',
        url: 'http://ohley.de/english/',
        hidden: true,
      },
      seahorse: {
        name: 'Seahorse Laser & Design',
        url: 'https://www.etsy.com/shop/SeahorseLaserDesign?section_id=24360565',
        hidden: true,
      },
      self_published: {
        name: 'Self-published',
        url: 'https://18xx.games',
        hidden: true,
      },
      traxx: {
        name: 'TraXX',
        url: 'https://traxx-denver.com/games/',
      },
      wood_18: {
        name: '18Wood',
        url: 'https://www.etsy.com/shop/18WOOD',
        hidden: true,
      },
      zman_games: {
        name: 'Z-MAN Games',
        url: 'https://zmangames.com/',
        hidden: true,
      },
    }.freeze
  end
end
